import * as React from 'react';
import * as mui from '@mui/material';
import * as icons from '@mui/icons-material';

const StyledIconButton = mui.styled((iconButtonProps: mui.IconButtonProps) => <mui.IconButton {...iconButtonProps} />)(({ theme }) => ({
	background: theme.palette.primary.main,
	boxShadow: '0px 0px 16px 0px rgba(0, 0, 0, .5)',
	':hover': {
		background: theme.palette.primary.light,
	},
}));

const IFrame = mui.styled('iframe')(() => ({
	width: '100vw',
	height: `${100 / Math.SQRT2}vw`,
	maxWidth: '950px',
	maxHeight: `${Math.round(950 / Math.SQRT2)}px`,
	border: 'none!important',
	outline: '0!important',
	margin: '0!important',
	padding: '0!important',
}));

interface BookCarouselProps {
	canShowPreview: boolean;
	bookVariables: BookVariables;
	BoxProps?: mui.BoxProps;
}

export default function BookCarousel(props: BookCarouselProps) {
	const { canShowPreview, bookVariables, BoxProps } = props;

	const [page, setPage] = React.useState(1);
	const [loading, setLoading] = React.useState(true);

	const pageUrlArgs = Object.entries(bookVariables)
		.map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
		.join('&');

	const handleLeftButtonClick = () => {
		const newPage = page - 1;
		setPage(newPage < 1 ? 38 : newPage);
		setLoading(true);
	};

	const handleRightButtonClick = () => {
		const newPage = page + 1;
		setPage(newPage > 38 ? 1 : newPage);
		setLoading(true);
	};

	const handleOnPageLoad = () => {
		setLoading(false);
	};

	return (
		<mui.Box {...BoxProps} sx={{ ...BoxProps?.sx, position: 'relative' }}>
			<mui.LinearProgress sx={{ display: loading ? undefined : 'none', position: 'absolute', top: 0, width: '100%' }} />

			<IFrame
				src={
					canShowPreview
						? `https://faboola-renderer-wordpress-ij2yppslba-ew.a.run.app/render/${bookVariables.selectedStory}/lq/${page}?${pageUrlArgs}`
						: ''
				}
				onLoad={handleOnPageLoad}
				title={canShowPreview ? `faboola preview (page ${page})` : 'faboola preview placeholder'}
			/>

			<mui.Tooltip title='Pagina precedente' aria-label='pagina precedente'>
				<StyledIconButton
					onClick={handleLeftButtonClick}
					sx={{ position: 'absolute', bottom: theme => theme.spacing(3), left: theme => theme.spacing(3) }}
				>
					<icons.ArrowBackRounded />
				</StyledIconButton>
			</mui.Tooltip>

			<mui.Tooltip title='Pagina successiva' aria-label='pagina successiva'>
				<StyledIconButton
					onClick={handleRightButtonClick}
					sx={{ position: 'absolute', bottom: theme => theme.spacing(3), right: theme => theme.spacing(3) }}
				>
					<icons.ArrowForwardRounded />
				</StyledIconButton>
			</mui.Tooltip>
		</mui.Box>
	);
}
